module.exports = __webpack_public_path__ + "img/headQMount_2comp.6dd5398e.png";